import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { Gapper } from '../../../../../ui/utils';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing } from '../../../../../ui/utils';
import { SectionHeading } from '../../../../../ui/typography';

export const Wrapper = styled(Gapper)(({ theme }) => ({
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  maxWidth: 1100,
  margin: '0 auto',
  backgroundColor: colors.whiteText,
  borderRadius: 40,
  padding: 10,
  boxShadow:
    ' -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)',
  gap: 10,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    borderRadius: 24,
  },
}));

export const Image = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: 500,
  height: '100vh',
  maxHeight: 520,
  objectFit: 'cover',
  borderRadius: 40,
  [theme.breakpoints.down('md')]: {
    maxWidth: 350,
    maxHeight: 350,
    borderRadius: 20,
  },
}));

export const TextWrapper = styled(Gapper)(({ theme }) => ({
  gap: 30,
  padding: 55,
  [theme.breakpoints.down(1000)]: {
    padding: 30,
  },
  [theme.breakpoints.down('md')]: {
    padding: '30px 24px',
    gap: 20,
  },
  [theme.breakpoints.down('sm')]: {
    padding: '24px 16px',
  },
}));

export const Title = styled(SectionHeading)(({ theme }) => ({
  fontFamily: fontFamilies.gothamBook,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(50, -1),
  textAlign: 'left',
  color: theme.palette.text.primary,
  [theme.breakpoints.down(1000)]: {
    fontSize: '36px',
    lineHeight: '42px',
    letterSpacing: figmaLetterSpacing(36, -1),
    textAlign: 'left',
  },
  [theme.breakpoints.down('lg')]: {
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '34px',
    letterSpacing: figmaLetterSpacing(28, -1),
  },
}));

export const ListWrapper = styled(Gapper)(({ theme }) => ({
  gap: 23,
  [theme.breakpoints.down('md')]: {
    gap: 18,
  },
  [theme.breakpoints.down('sm')]: {
    gap: 14,
  },
}));

export const ListItem = styled(Gapper)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 16,
  justifyContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    gap: 12,
  },
}));

export const ListItemText = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: 1.27,
  letterSpacing: figmaLetterSpacing(18, 2),
  textAlign: 'left',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
    lineHeight: 1.35,
    letterSpacing: figmaLetterSpacing(16, 2),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    letterSpacing: figmaLetterSpacing(14, 2),
  },

  '& b': {
    fontWeight: 600,
  },
}));
